import { Grid, MultiSelect, Select } from '@mantine/core';
import React from 'react';
import { renderSkeletonLoader } from './helper';
import { moduleRoles } from '../../../constants';

export const Add = ({ handleChange, formData, options, loading }) => {
  const { role, country, producingPlant, typeOfRequest, typeOfSKU } = formData;
  const countries = options.countries;
  const plants = options.plantsByCountry[country] || [];
  const {
    is_scoped_to_country,
    is_scoped_to_plant,
    is_scoped_to_type_of_sku,
    is_scoped_to_type_of_request,
  } = options.validators || {};

  return (
    <>
      <Grid>
        <Grid.Col span={6}>
          <Select
            label='Select Role'
            searchable
            placeholder='Search or select a role'
            clearable
            nothingFound='Nothing found'
            onChange={(value) => handleChange(value, 'role')}
            data={moduleRoles['Costing Request']}
            withinPortal
            withAsterisk
            value={role}
          />
        </Grid.Col>

        {(is_scoped_to_country || loading) && (
          <Grid.Col span={6}>
            {loading ? (
              renderSkeletonLoader(loading)
            ) : (
              <Select
                label='Select Country'
                searchable
                placeholder='Search or select a country'
                clearable
                nothingFound='Nothing found'
                onChange={(value) => handleChange(value, 'country')}
                data={countries}
                withinPortal
                withAsterisk
                value={country}
              />
            )}
          </Grid.Col>
        )}

        {is_scoped_to_plant && (
          <Grid.Col span={6}>
            <MultiSelect
              label='Select Production Details'
              searchable
              placeholder='Search or select plants'
              clearable
              nothingFound='Nothing found'
              onChange={(value) => handleChange(value, 'producingPlant')}
              data={plants}
              withinPortal
              withAsterisk
              value={producingPlant}
            />
          </Grid.Col>
        )}

        {is_scoped_to_type_of_sku && (
          <Grid.Col span={6}>
            <Select
              label='Select Type of SKU'
              placeholder='Select SKU'
              onChange={(value) => handleChange(value, 'typeOfSKU')}
              data={options.typeOfSKUs}
              withinPortal
              withAsterisk
              value={typeOfSKU}
            />
          </Grid.Col>
        )}
        {is_scoped_to_type_of_request && (
          <Grid.Col span={6}>
            <Select
              label='Select Type of Request'
              placeholder='Select Request'
              onChange={(value) => handleChange(value, 'typeOfRequest')}
              data={options.typeOfRequests}
              withinPortal
              withAsterisk
              value={typeOfRequest}
            />
          </Grid.Col>
        )}
      </Grid>
    </>
  );
};
